var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEligible)?_c('span',{staticClass:"qcw-icon",attrs:{"title":"Ads Tracker"},on:{"click":_vm.showAdsTrackerPopup}},[_c('label',[_c('icon',{attrs:{"name":"ic-ads-tracker","fill":_vm.core.UI.colors.formMessageIconColor}})],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b4dde70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ads-tracker/Toggle.vue
// module id = jaC3
// module chunks = 0